import { events } from '../api';
import { uploadEngine } from '../upload/upload.engine';

const ENGINE_OFF = 'off';
const FULL_PROGRESS = 100;
const COMPLETED = 'completed';
const UPLOADING = 'uploading';

const STATE_TEXT = Object.freeze({
    slow: 'conexão lenta, o envio continua sozinho',
    offline: 'continua quando a internet voltar',
    confirming: 'confirmando o arquivo',
});

const failureMessage = (names, anySent) => (anySent
    ? `Não foi possível enviar ${names}. Os demais arquivos foram enviados; envie novamente só o que falhou.`
    : `Não foi possível enviar ${names}. Tente novamente.`);

const progressOf = (showProgress) => (info, progress) => events.emmit('onProgressDeterminate', { info, progress, show: showProgress });

const stateHandler = (file, showProgress, onProgress) => {
    const last = { percent: 0 };
    const emit = progressOf(showProgress);
    return (state) => {
        if (state.state === UPLOADING) {
            last.percent = state.percent;
            if (typeof onProgress === 'function') onProgress(file, state.percent);
            return emit(`Fazendo Upload do arquivo: ${file.name}`, state.percent);
        }
        return STATE_TEXT[state.state] ? emit(`${file.name}: ${STATE_TEXT[state.state]}`, last.percent) : undefined;
    };
};

const settled = (promise) => promise.then(
    outcome => outcome,
    error => ({ status: 'failed', message: error && error.response && error.response.data && error.response.data.message }),
);

const batchFailure = (files, outcomes) => {
    const failedIndexes = Array.from(files.keys()).filter(index => outcomes[index].status !== COMPLETED);
    const names = failedIndexes.map(index => files[index].name).join(', ');
    return Object.assign(new Error('upload'), { info: failureMessage(names, failedIndexes.length < files.length) });
};

const uploadEach = ({ files, targetKind, targetOf, showProgress, onProgress }) => Promise.all(files.map(file => settled(uploadEngine.upload({
    file, targetKind, target: targetOf(file), onState: stateHandler(file, showProgress, onProgress),
}))));

const settleBatch = (files, outcomes) => {
    if (outcomes.some(outcome => outcome.engine === ENGINE_OFF)) return null;
    events.emmit('onProgressDeterminate', { info: 'Upload concluído', progress: FULL_PROGRESS, show: false });
    if (outcomes.some(outcome => outcome.status !== COMPLETED)) throw batchFailure(files, outcomes);
    return outcomes;
};

export const uploadThroughEngine = async ({ files, targetKind, targetOf, showProgress = true, onProgress = null }) =>
    settleBatch(files, await uploadEach({ files, targetKind, targetOf, showProgress, onProgress }));

const FAILED = 'failed';
const UNSENT_MESSAGE = 'Não foi possível enviar este arquivo.';

const settledOf = (outcome) => (outcome.status === COMPLETED
    ? { status: COMPLETED, document: outcome.result.document }
    : { status: FAILED, message: outcome.message || UNSENT_MESSAGE });

const refusedOf = (error) => ({ status: FAILED, message: (error && error.response && error.response.data && error.response.data.message) || UNSENT_MESSAGE });

const uploadOne = ({ file, targetKind, targetOf, onFileState, onFileSettled }) => {
    const settle = (settled) => {
        onFileSettled(file, settled);
        return settled;
    };
    return uploadEngine.upload({ file, targetKind, target: targetOf(file), onState: (state) => onFileState(file, state) })
        .then(outcome => (outcome.engine === ENGINE_OFF ? outcome : settle(settledOf(outcome))), error => settle(refusedOf(error)));
};

export const uploadEachThroughEngine = async ({ files, targetKind, targetOf, onFileState = () => {}, onFileSettled = () => {} }) => {
    const outcomes = await Promise.all(files.map(file => uploadOne({ file, targetKind, targetOf, onFileState, onFileSettled })));
    return outcomes.some(outcome => outcome.engine === ENGINE_OFF) ? null : outcomes;
};
